import { render, staticRenderFns } from "./FileDownloadLink.vue?vue&type=template&id=6f059c79&scoped=true&"
import script from "./FileDownloadLink.vue?vue&type=script&lang=js&"
export * from "./FileDownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadLink.vue?vue&type=style&index=0&id=6f059c79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f059c79",
  null
  
)

export default component.exports